import React from 'react';
import { ProgressBarProps } from './interface';

import { Container } from './styles';

const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { bgColor, completed } = props;

  return (
    <Container completed={completed} bgColor={bgColor}>
      <div>
        <span>{`${completed}%`}</span>
      </div>
    </Container>
  );
};

export default ProgressBar;